module.exports = __webpack_public_path__ + "static/media/logo-white.0b66dd04.svg";